<template>
  <div>
    <div :style="cssVariables" class="evan-clock" @click="copyText(currentTime,'时间')">
      <div class="evan-clock__content">

        <div v-for="(item,index) in 30" :key="`clock_mark_${index}`" :style="{rotate:`${index * 6}deg`}"
             class="clock__mark">
          <div :class="`clock-mark${index%5===0?'__main':''}`"></div>
          <div :class="`clock-mark${index%5===0?'__main':''}`"></div>
        </div>
        <!-- 十二小时刻度 -->
        <div v-for="(item,index) in 12" :key="`clock_num_${index}`" :style="{rotate:`${item * 30}deg`}"
             class="clock__number">
          <span :class="`clock-number${item%3===0?'__main':''}`" :style="{rotate:`-${item * 30}deg`}">{{ item }}</span>
        </div>
        <!--   时、分、秒针，表盘圆点  -->
        <div :style="{rotate: hoursRotate}" class="hours-pointer">
          <div
              :style="{backgroundColor:hourDot}"
              style="width: 50%;height: 20%;;margin-top: 30%;border-radius: 10em"></div>
        </div>
        <div :style="{rotate: minuteRotate}" class="minute-pointer">
          <div
              :style="{backgroundColor:minuteDot}"
              style="width: 40%;height: 30%;margin-top: 40%;border-radius: 10em"></div>
        </div>
        <div ref="secondPointer" :style="{rotate: secondRotate}" class="second-pointer">
          <div
              :style="{backgroundColor:secondDot}" style="width: 100%;height: 10%;border-radius: 10em"></div>
        </div>
        <div class="clock-center-dot">
          <div class="dot_center"></div>
        </div>
      </div>
    </div>
    <div v-if="showControl">

      <div class="settine-content">
        <!--     控制台数字时间   -->
        <el-collapse-transition>
          <div v-show="!showColor" style="width: 100%">
            <div class="row-setting">
              <div style="width: 100%;line-height: 2;text-align: center">
                <div style="font-size: 2.5em">{{ currentTime|dateformat('YY年MM月DD日') }}</div>
                <div>{{ currentTime|dateformat('HH时mm分ss秒') }} GMT{{ currentTime|dateformat('Z') }}</div>
              </div>
            </div>
          </div>
        </el-collapse-transition>
        <!--     平滑指针开关   -->
        <div class="row-setting">
          <div class="setting_columns">
            <div class="setting__field">
              <div>时钟类型</div>
              <evan-switch v-model="clockType" size=".7em" border :options="[{label:'静音时钟',value:true},{label:'有声时钟',value:false}]"></evan-switch>
            </div>
          </div>
        </div>
        <div class="row-setting" >
          <div class="setting_columns">
            <div class="setting__field">
              <div>炸弹音效</div>
              <van-switch v-model="boundClock" :disabled="!audioClock" :active-value="true" :inactive-value="false" size="18"></van-switch>
            </div>
          </div>
        </div>
        <!--      色彩管理器  -->
        <div class="row-setting">
          <div class="setting_columns">
            <div class="setting__field" @click="showColor=!showColor">
              <div>色彩管理</div>
              <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;gap: 1em">
                <div v-if="colorIsChange" style="display: flex;flex-direction: column;justify-content: center;align-items: center"
                     @click.stop="resetColorConfig">
                  <i class="iconfont icon-reset"></i>
                  <div style="font-size: .5em">重置颜色</div>
                </div>
                <i :style="{rotate:showColor?'90deg':''}" class="iconfont icon-arrow-right"
                   style="transition: rotate .3s"></i>
              </div>
            </div>
            <el-collapse-transition>
              <div v-show="showColor" style="width: 100%;overflow: hidden">
                <div style="font-size: .7em;color: var(--footer-color)">
                  请注意：当更改颜色后，无法自动根据主题色变化(在修改后您仍可以通过重置按钮重置时钟颜色)！
                </div>
                <van-collapse v-model="collapseActiveName" :border="false" accordion not-border style="width: 100%;">
                  <van-collapse-item :border="false" name="1" title="指针颜色">
                    <div style="display:grid;grid-template-columns: repeat(3,1fr) ;gap: .5em">
                      <div :class="currentColorName==='hourPointer'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('hourPointer')">
                        <div :style="{backgroundColor:hourPointer,color:hourPointer}" class="current-color-block"></div>
                        <div class="current-color-block__text">时针</div>
                      </div>
                      <div :class="currentColorName==='minutePointer'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('minutePointer')">
                        <div :style="{backgroundColor:minutePointer,color:minutePointer}"
                             class="current-color-block"></div>
                        <div class="current-color-block__text">分针</div>
                      </div>
                      <div :class="currentColorName==='secondPointer'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('secondPointer')">
                        <div :style="{backgroundColor:secondPointer,color:secondPointer}"
                             class="current-color-block"></div>
                        <div class="current-color-block__text">秒针</div>
                      </div>
                      <div :class="currentColorName==='hourDot'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('hourDot')">
                        <div :style="{backgroundColor:hourDot,color:hourDot}" class="current-color-block"></div>
                        <div class="current-color-block__text">时针荧光</div>
                      </div>
                      <div :class="currentColorName==='minuteDot'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('minuteDot')">
                        <div :style="{backgroundColor:minuteDot,color:minuteDot}" class="current-color-block"></div>
                        <div class="current-color-block__text">分针荧光</div>
                      </div>
                      <div :class="currentColorName==='secondDot'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('secondDot')">
                        <div :style="{backgroundColor:secondDot,color:secondDot}" class="current-color-block"></div>
                        <div class="current-color-block__text">秒针荧光</div>
                      </div>
                    </div>
                  </van-collapse-item>
                  <van-collapse-item :border="false" name="2" title="表盘颜色">
                    <div style="display:grid;grid-template-columns: repeat(4,1fr) ;gap: .5em">
                      <div :class="currentColorName==='clockBackground'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('clockBackground')">
                        <div :style="{backgroundColor:clockBackground,color:clockBackground}"
                             class="current-color-block"></div>
                        <div class="current-color-block__text">背景色</div>
                      </div>
                      <div :class="currentColorName==='clockBorder'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('clockBorder')">
                        <div :style="{backgroundColor:clockBorder,color:clockBorder}" class="current-color-block"></div>
                        <div class="current-color-block__text">表盘边框</div>
                      </div>
                      <div :class="currentColorName==='clockDotCenter'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('clockDotCenter')">
                        <div :style="{backgroundColor:clockDotCenter,color:clockDotCenter}"
                             class="current-color-block"></div>
                        <div class="current-color-block__text">圆心</div>
                      </div>
                      <div :class="currentColorName==='clockDot'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('clockDot')">
                        <div :style="{backgroundColor:clockDot,color:clockDot}" class="current-color-block"></div>
                        <div class="current-color-block__text">圆心边框</div>
                      </div>
                    </div>
                  </van-collapse-item>
                  <van-collapse-item :border="false" name="3" title="刻度/标记颜色">
                    <div style="display:grid;grid-template-columns: repeat(4,1fr) ;gap: .5em">
                      <div :class="currentColorName==='clockMark'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('clockMark')">
                        <div :style="{backgroundColor:clockMark,color:clockMark}" class="current-color-block"></div>
                        <div class="current-color-block__text">刻度</div>
                      </div>
                      <div :class="currentColorName==='clockHighlightMark'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('clockHighlightMark')">
                        <div :style="{backgroundColor:clockHighlightMark,color:clockHighlightMark}"
                             class="current-color-block"></div>
                        <div class="current-color-block__text">高亮刻度</div>
                      </div>
                      <div :class="currentColorName==='clockNum'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('clockNum')">
                        <div :style="{backgroundColor:clockNum,color:clockNum}" class="current-color-block"></div>
                        <div class="current-color-block__text">数字</div>
                      </div>
                      <div :class="currentColorName==='clockNunHighlight'?`current-color__active`:''" class="current-color__content"
                           @click="activeColor('clockNunHighlight')">
                        <div :style="{backgroundColor:clockNunHighlight,color:clockNunHighlight}"
                             class="current-color-block"></div>
                        <div class="current-color-block__text">高亮数字</div>
                      </div>
                    </div>
                  </van-collapse-item>
                </van-collapse>


              </div>
            </el-collapse-transition>
          </div>
        </div>
      </div>
    </div>
    <van-dialog v-model="showDialog" :show-confirm-button="false" title="提示">

      <div>是否开启有声时钟？</div>
      <div style="width: 100%;margin-top: 1em">
        <van-button block plain size="small" @click="clockType=true;showDialog=false;" type="success">开启</van-button>
        <van-button block plain size="small" @click="showDialog=false"  type="danger">不开启</van-button>
      </div>

    </van-dialog>
    <evan-color-picker ref="colorPicker"  v-model="vModelColor" output-type="string" output="hex8"  @cancel="cancleChangeColor"  @confirm="inputColor">
      <template #trigger>
        <div></div>
      </template>
    </evan-color-picker>
  </div>

</template>

<script>
import Chrome from "@/components/vue-color/components/Chrome.vue";
import wxApi, {getCurrentUrl} from "@/utils/wxAPI";
import {Dialog, Notify} from "vant";
import EvanSwitch from "@/components/EvanSwitch.vue";
import EvanColorPicker from "@/components/EvanColorPicker.vue";

const storageKey = "clock-color-config";
const initData = {
  hourPointer: 'var(--primary-color)',
  hourDot: 'yellow',
  minutePointer: 'var(--positive-color)',
  minuteDot: 'yellow',
  secondPointer: 'var(--negative-color)',
  secondDot: 'yellow',
  clockBackground: 'var(--bg-color)',
  clockBorder: 'var(--border-color)',
  clockDot: 'var(--text-color)',
  clockDotCenter: 'var(--bg-color)',
  clockMark: 'var(--footer-color)',
  clockHighlightMark: 'var(--primary-color)',
  clockNum: 'var(--text-color)',
  clockNunHighlight: 'var(--primary-color)',
};


export default {
  name: "EvanClock",
  components: {EvanColorPicker, EvanSwitch, Chrome},
  props: {
    notSmooth: {
      type: Boolean,
      default: false,
    },
    showControl: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    colorIsChange() {
      return JSON.stringify(initData).replaceAll(' ', '') !== JSON.stringify(this.config).replaceAll(' ', '');
    },
    hoursRotate() {
      return `${30 * this.hourNumber + ( .5 * this.minuteNumber )}deg`;

    },
    minuteRotate() {
      return `${6 * this.minuteNumber + ( .1 * this.secondNumber )}deg`
    },
    secondRotate() {
      return `${6 * this.secondNumber + (this.smooth ? .006 * this.millisecondNumber : 0)}deg`
    },
    cssVariables() {
      return {
        '--hour-pointer': this.hourPointer,
        '--hour-dot': this.hourDot,
        '--minute-pointer': this.minutePointer,
        '--minute-dot': this.minuteDot,
        '--second-pointer': this.secondPointer,
        '--second-dot': this.secondDot,
        //表盘背景和边框
        '--clock-background': this.clockBackground,
        '--clock-border': this.clockBorder,
        //表盘中心点
        '--clock-dot': this.clockDot,
        '--clock-dot-center': this.clockDotCenter,
        //十二小时刻度
        '--clock-mark': this.clockMark,
        '--clock-highight-mark': this.clockHighlightMark,
        '--clock-num': this.clockNum,
        '--clock-num-highlight': this.clockNunHighlight,

      };
    },
  },
  data() {
    return {
      collapseActiveName: '',
      hourNumber: 0,
      minuteNumber: 0,
      secondNumber: 0,
      millisecondNumber: 0,
      currentTime: '',
      smooth: true,
      clockType:true,
      currentColorName: '',
      vModelColor: '',
      smoothOriginal: false,
      hourPointer: 'var(--primary-color)',
      hourDot: 'yellow',
      minutePointer: 'var(--positive-color)',
      minuteDot: 'yellow',
      secondPointer: 'var(--negative-color)',
      secondDot: 'yellow',
      clockBackground: 'var(--bg-color)',
      clockBorder: 'var(--border-color)',
      clockDot: 'var(--text-color)',
      clockDotCenter: 'var(--bg-color)',

      clockMark: 'var(--footer-color)',
      clockHighlightMark: 'var(--primary-color)',

      clockNum: 'var(--text-color)',
      clockNunHighlight: 'var(--primary-color)',

      showColor: false,
      config: [],
      audioPlaying: false,
      currentAudio: '',
      audioFiles: {
        oneSecond: null,
        fiftyNineSeconds: null,
        oneMinute: null
      },
      boundAudioFiles: {
        oneSecond:null,
        S46:null,
        S47:null,
        S48:null,
        S49:null,
        S50:null,
        S51:null,
        S52:null,
        S53:null,
        S54:null,
        S55:null,
        S56:null,
        S57:null,
        S58:null,
        S59:null,
      },
      audioClock: false,
      boundClock: false,
      showDialog: false,

    }
  },
  methods: {
    activeColor(attrName) {
      this.currentColorName = attrName;
      this.vModelColor = this[attrName];
    },
    cancleChangeColor() {
      this.currentColorName = '';
      this.vModelColor = '';
    },
    inputColor(value) {
      this.setValue(this.currentColorName, value.hex8);
      this.showColor = false;
      this.currentColorName = '';
      this.vModelColor = '';
    },
    copyText(text, headers = '') {
      this.$CF.copyText(text, headers, '', false);
    },
    getTime() {

      this.v = setInterval(() => {
        this.currentTime = this.$moment(Date.now()).format('yyyy-MM-DD HH:mm:ss.SSSZZ');
        this.hourNumber = Number.parseInt(this.$moment(this.currentTime).format('hh'));
        this.minuteNumber = Number.parseInt(this.$moment(this.currentTime).format('mm'));
        this.secondNumber = Number.parseInt(this.$moment(this.currentTime).format('ss'));
        this.millisecondNumber = Number.parseInt(this.$moment(this.currentTime).format('SSS'));

      }, 1)
    },
    readLocalStorage() {
      let config = localStorage.getItem(storageKey);
      if (!config) {
        localStorage.setItem(storageKey, JSON.stringify(initData));
        config = JSON.stringify(initData);
      }
      this.readConfig(config);
    },
    resetColorConfig() {
      localStorage.removeItem(storageKey);
      this.readLocalStorage();
    },
    readConfig(config) {
      let parse = JSON.parse(config);
      Object.entries(parse)
          .map(([key, value]) => this[key] = value);
      this.config = parse;
    },
    setValue(keyName, value) {
      this.config[keyName] = value;
      this[keyName] = value;
      localStorage.setItem(storageKey, JSON.stringify(this.config));
    },
    // 初始化音频
    initAudio() {
      var s = document.createElement('span');
      document.documentElement.appendChild(s);
      s.click();
      // 注意：实际项目中路径应为 '@/assets/sound/1s.ogg'
      this.audioFiles.oneSecond = new Audio(require("@/assets/sound/1s.ogg"));
      this.audioFiles.fiftyNineSeconds = new Audio(require("@/assets/sound/59s.ogg"));
      this.audioFiles.oneMinute = new Audio(require("@/assets/sound/1m.ogg"));
      this.boundAudioFiles.oneSecond = new Audio(require("@/assets/sound/bound/1s.ogg"));
      this.boundAudioFiles.S46 = new Audio(require("@/assets/sound/bound/46s.ogg"));
      this.boundAudioFiles.S47 = new Audio(require("@/assets/sound/bound/47s.ogg"));
      this.boundAudioFiles.S48 = new Audio(require("@/assets/sound/bound/48s.ogg"));
      this.boundAudioFiles.S49 = new Audio(require("@/assets/sound/bound/49s.ogg"));
      this.boundAudioFiles.S50 = new Audio(require("@/assets/sound/bound/50s.ogg"));
      this.boundAudioFiles.S51 = new Audio(require("@/assets/sound/bound/51s.ogg"));
      this.boundAudioFiles.S52 = new Audio(require("@/assets/sound/bound/52s.ogg"));
      this.boundAudioFiles.S53 = new Audio(require("@/assets/sound/bound/53s.ogg"));
      this.boundAudioFiles.S54 = new Audio(require("@/assets/sound/bound/54s.ogg"));
      this.boundAudioFiles.S55 = new Audio(require("@/assets/sound/bound/55s.ogg"));
      this.boundAudioFiles.S56 = new Audio(require("@/assets/sound/bound/56s.ogg"));
      this.boundAudioFiles.S57 = new Audio(require("@/assets/sound/bound/57s.ogg"));
      this.boundAudioFiles.S58 = new Audio(require("@/assets/sound/bound/58s.ogg"));
      this.boundAudioFiles.S59 = new Audio(require("@/assets/sound/bound/59s.ogg"));
      // 设置音频属性
      Object.values(this.audioFiles).forEach(audio => {
        audio.loop = false;
        audio.volume = 0.8;
      });
      Object.values(this.boundAudioFiles).forEach(audio => {
        audio.loop = false;
        audio.volume = 0.8;
      });
    },
    // 播放音频
    playAudio(type) {
      // 停止当前播放的音频
      this.stopAudio();
      const audio = this[this.boundClock&&type!=='oneMinute'?'boundAudioFiles':'audioFiles'][type];
      if (!audio) return;

      // 播放音频
      audio.currentTime = 0;
      audio.play()
          .then(() => {
            this.audioPlaying = true;
            this.currentAudio = this.getAudioFileName(type);
          })
          .catch(error => {
            console.error('播放失败:', error);
            this.audioPlaying = false;
          });
    },
    // 停止所有音频
    stopAudio() {
      Object.values(this.audioFiles).forEach(audio => {
        audio.pause();
        audio.currentTime = 0;
      });
      Object.values(this.boundAudioFiles).forEach(audio => {
        audio.pause();
        audio.currentTime = 0;
      });
      this.audioPlaying = false;
    },

    // 获取音频文件名
    getAudioFileName(type) {
      const map = {
        oneSecond: '1s.ogg',
        fiftyNineSeconds: '59s.ogg',
        oneMinute: '1m.ogg'
      };
      if (!this.boundClock||type==='oneMinute') {
        return type==='oneMinute'?map.oneSecond:map[type] || '';
      }
      const boundMap = {
        oneSecond: '1s.ogg',

        S55:'55s.ogg',
        S56:'56s.ogg',
        S57:'57s.ogg',
        S58:'58s.ogg',
        S59:'59s.ogg',
      };
      return boundMap[type] || '';
    },
  },
  mounted() {
    // wxApi.updateAppMessageShare({
    //   title: '测试标题',
    //   desc: '这是一个测试的标题描述',
    //   link:getCurrentUrl(),
    //   imgUrl: 'https://cdn4.winhlb.com/2025/11/15/69177f86ba197.png',
    //   success: (s) => {
    //     console.log("success",s);
    //     Dialog({message: '分享设置成功'})
    //   },
    //   fail:(f) =>{
    //     console.log("fail",f)
    //   }
    // }).then(res =>{
    //   Notify({message: JSON.stringify(res)})
    //   console.log('res',res);
    // }).catch(cat =>{
    //   Dialog({message:JSON.stringify(cat)})
    //   console.log('cat',cat)
    // })
    //wxApi.showAllNonBaseMenuItem();
    this.initAudio()
    if (this.notSmooth) {
      this.clockType = false;
    }
    if (!this.showControl) {
      this.showDialog = true;
    }
    this.readLocalStorage();
    this.getTime();
  },watch: {
    // 监听秒数变化
    secondNumber(newVal, oldVal) {
      if (newVal === oldVal) return;

      // 根据秒数播放对应的音频
      if (this.audioClock) {
        if (!this.boundClock) {
          if (newVal >= 1 && newVal <= 58) {
            this.playAudio('oneSecond');
          } else if (newVal === 59) {
            this.playAudio('fiftyNineSeconds');
          } else if (newVal === 0) {
            this.playAudio('oneMinute');
          }
        }else{
          if (newVal >= 1 && newVal <= 54) {
            this.playAudio('oneSecond');
          } else if (newVal === 0) {
            this.playAudio('oneMinute');
          }else{
            this.playAudio(`S${newVal}`);
          }
        }
      }
    },
    clockType: {
      handler(newVal) {
        this.smooth = newVal;
        this.audioClock = !newVal;
      },
    },
    audioClock: {
      handler(newVal) {
        if (newVal) {

          this.initAudio();
        }
      },
    },
    currentColorName:{
      handler(newVal) {
        if (newVal) {
          this.$refs.colorPicker.open();
        }
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.settine-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: .5em;
}

.row-setting {
  width: 100%;
  outline: none;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: .5em;
  padding: .5em 1em;
  border-radius: .5em;
  border: 1px solid var(--border-color);

  background-color: var(--input-bg);
}

.setting_columns {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: .3em;
  width: 100%;
}

.current-color__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: .5em;
}

.current-color-block {
  width: 50%;
  border-radius: 1em;
  border: .1em solid var(--text-color);
  aspect-ratio: 1/1;
  box-shadow: 0 0 0 var(--primary-color);
  transition: box-shadow .3s;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;

    border-radius: 12px;
    z-index: 1;
    /* 关键属性：颜色反相 */
    filter: invert(100%);
  }
}

.current-color-block__text {
  text-align: center;
}

.current-color__active {
  .current-color-block {
    box-shadow: 0 0 1em currentColor;
  }

  .current-color-block__text {
    color: var(--primary-color);
  }
}

.setting__field {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: .3em;
}

.evan-clock {
  outline: none;
  box-sizing: border-box;
  width: 50%;
  border-radius: 50%;
  aspect-ratio: 1/1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--clock-border);
  margin: 1em auto;

  .evan-clock__content {
    border-radius: 50%;
    width: 95%;
    aspect-ratio: 1/1;
    margin: 0 auto;
    background-color: var(--clock-background);
    position: relative;
    overflow: hidden;

    .clock__mark {
      position: absolute;
      width: 100%;
      top: calc(calc(100% - .5px) / 2);
      left: 0;
      height: .5px;
      text-align: center;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      & .clock-mark, & .clock-mark__main {
        width: 1.5%;
        background-color: var(--clock-mark);
        height: 1px;
      }

      & .clock-mark__main {
        width: 3%;
        background-color: var(--clock-highight-mark);
      }
    }

    .clock__number {
      position: absolute;
      width: 90%;
      aspect-ratio: 1/1;
      top: calc(calc(100% - 90%) / 2);
      left: calc(calc(100% - 90%) / 2);
      border-radius: 90%;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      & .clock-number {
        position: absolute;
        color: var(--clock-num);
        font-size: 1em;
        font-weight: normal;
      }

      & .clock-number__main {
        font-weight: bolder;
        color: var(--clock-num-highlight);
        font-size: 1.3em;

      }
    }

    .hours-pointer {
      width: 4%;
      position: absolute;
      left: calc(calc(100% - 4%) / 2);
      top: 30%;
      height: 20%;
      background-color: var(--hour-pointer);
      border-radius: 10em;
      transform-origin: 50% 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    .minute-pointer {
      width: 3%;
      position: absolute;
      left: calc(calc(100% - 3%) / 2);
      top: 20%;
      height: 30%;
      background-color: var(--minute-pointer);
      border-radius: 10em;
      transform-origin: 50% 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    .second-pointer {
      width: 1%;
      position: absolute;
      left: calc(calc(100% - 1%) / 2);
      top: 10%;
      height: 40%;
      background-color: var(--second-pointer);
      border-radius: 10em;
      transform-origin: 50% 100%;
      transition: all .001s;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    .clock-center-dot {
      width: 6%;
      position: absolute;
      left: calc(calc(100% - 6%) / 2);
      top: calc(calc(100% - 6%) / 2);
      height: 6%;
      background-color: var(--clock-dot);
      border-radius: 10em;

      .dot_center {
        width: 50%;
        position: absolute;
        aspect-ratio: 1/1;
        top: calc(calc(100% - 50%) / 2);
        left: calc(calc(100% - 50%) / 2);
        background-color: var(--clock-dot-center);
        border-radius: 10em;
      }
    }
  }
}

</style>
